// How many days to render in the 'week view'
export const DAYS_TO_RENDER = 7;
